/* Lukante theme JS */
jQuery(document).ready(function () {
    jQuery(window).on("scroll", function () {
        if (jQuery(window).scrollTop() > 50) {
            jQuery("#main-nav").addClass("active-header");
           // jQuery(".navbar-brand img").attr("src", theme_directory + "/img/logo_black.png");
          //  jQuery(".navbar-brand img").attr("srcset", theme_directory + "/img/logo_black.png");
         } else {
            //remove the background property so it comes transparent again (defined in your css)
            jQuery("#main-nav").removeClass("active-header");
         //   jQuery(".navbar-brand img").attr("src", theme_directory + "/img/logo_white.png");
          //  jQuery(".navbar-brand img").attr("srcset", theme_directory + "/img/logo_white.png");
        }
    });

    /* add to card btn custom */
    jQuery(".add_to_cart_button").attr("href", "./kontakt");
});

  /* get height of the HERO section and set to image */
jQuery(document).ready(function () {
  
    var sectionhero = document.querySelector('.section-hero');
    var sectionHeroHeight = sectionhero.offsetHeight;
    var sectionHeroImage = document.getElementsByClassName('section-hero__img'); //always return an array

    for(var i=0;i<sectionHeroImage.length;i++) {
    sectionHeroImage[i].style.height = sectionHeroHeight+"px";
}
});

jQuery(document).ready(function () {
jQuery(".wpfClearButton").addClass("accent-btn primary-btn");

});

